// Generated by https://quicktype.io
//
// To change quicktype's target language, run command:
//
//   Set quicktype target language

export const matchNames = ["AX","BY","CZ","AY","BZ","CX","AZ","BX","CY"];
export const homeLetters = ['A','B','C','D'];
export const visitingLetters = ['X','Y','Z','W'];

export interface Match {
    sheetId: number;
    coupe: boolean,
    atHome: boolean;
    id: number|undefined;
    player_team:string;
    season:string;
    name: string;    
    team: string;
    otherRanking: number;
    delta: number;
    opponent: string;
    date: string;
    score: Score;
    double: boolean;
}

export interface Score {
    me: number;
    other: number;
}

export interface Player {
    name: string;
    team: string;
    season: string;
    ranking: number;
}

export interface PlayerStatistic {
    win : number;
    loss : number;
    wonPoints : number;
    virtualRanking: number;
    player: Player;
}

export enum ResultType {
    NormalVictory = "NormalVictory",
    AbnormalVictory = "AbnormalVictory",
    NormalDefeat = "NormalDefeat",
    AbnormalDefeat = "AbnormalDefeat"
}

export interface ScalePoints {
    NormalVictory : number;
    NormalDefeat:  number;
    AbnormalVictory:number;
    AbnormalDefeat:number;
}

export interface Scale {
    min : number;
    max : number;
    points : ScalePoints;
}

export interface Meeting {
    sheetId : number;
    coupe: boolean;
    matches: Match[];
    team: string;
    date: string;
    totalGain: number;
    atHome: boolean;
}

export interface SheetMatch {
    home:number[];
    visiting:number[];
    score_home:number;
    score_visiting:number;
}

export interface SheetPlayer  {
    name: string;
    rank: number;
}

export interface ISheetTeam {
    name: string;
    incomplete: boolean;
}

export interface SheetHomeTeam extends ISheetTeam {
    A: SheetPlayer,
    B: SheetPlayer,
    C: SheetPlayer,
    D: SheetPlayer,
};

export interface SheetVisitingTeam extends ISheetTeam {
    X: SheetPlayer,
    Y: SheetPlayer,
    Z: SheetPlayer,
    W: SheetPlayer,
};

export interface SheetScore {
    AX:SheetMatch;
    BY:SheetMatch;
    CZ:SheetMatch;
    AY:SheetMatch;
    BZ:SheetMatch;
    CX:SheetMatch;
    AZ:SheetMatch;
    BX:SheetMatch;
    CY:SheetMatch;
    Double:SheetMatch;
    double_home:string[],
    double_visiting:string[]
}

export class Sheet {
    id: number = -1;
    coupe: boolean = false;
    date:string;
    home: SheetHomeTeam;
    visiting : SheetVisitingTeam;
    scores : SheetScore;
    constructor(d:string,h:SheetHomeTeam,v:SheetVisitingTeam,s:SheetScore) {
        this.date = d;
        this.home = h;
        this.visiting = v;
        this.scores =s;
    };    
}

export  let getKey = (sheet: Sheet):string => {
    if (sheet && sheet.home && sheet.visiting && sheet.date) {
        return `${sheet.home.name}/${sheet.visiting.name}/${sheet.date}`;
    }
    return "";
}

let emptyScores:SheetScore = 
    {
        AX : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        BY : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        CZ : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        AY : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        BZ : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        CX : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        AZ : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        BX : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        CY : {
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        Double : {            
            home:[0,0,0,0,0],
            visiting:[0,0,0,0,0],
            score_home:0,
            score_visiting:0
        },
        double_home : ['',''],
        double_visiting : ['',''],
    }

    let emptyHome: SheetHomeTeam = {
        name: "",
        incomplete:false,
        A:{
            name:"",
            rank:500
        },
        B:{
            name:"",
            rank:500
        },
        C:{
            name:"",
            rank:500
        },
        D: 
        {
            name:"",
            rank:500
        }
    };

    let emptyVisiting : SheetVisitingTeam = {
        name: '',
        incomplete:false,
        X:{
            name:"",
            rank:500
        },
        Y:{
            name:"",
            rank:500
        },
        Z:{
            name:"",
            rank:500
        },
        W: {
            name:"",
            rank:500
        }
    }

    export let emptySheet= new Sheet('',emptyHome,emptyVisiting,emptyScores);

export interface Account {
    login:string;
    password:string;
}    

export interface AuthorizedResult<T> {
    authorized: boolean
    result: T | undefined
}

export const unauthorizedAccess = <T>() => {
    return {
        authorized: false,
        result: undefined,
    }
}

export const authorized = <T>(result: T) => {
    return {
        authorized: true,
        result,
    }
}

export interface ShareLink {
    id:string
    account:string
    season:string
    team:string
}

export interface VirtualSession {
    id:string
    link:string
}

export interface Session{
    success:boolean,
    account:string,
    virtualSession: VirtualSession
}

export interface Log {
    id: number;
    operationId: string;
    date:string;
    account:string;
    season:string;
    team:string;
    sheetId:number;
    message:string;
}

export interface RequestContext {
    sessionId:string;
    operationId: string;
    sheetId: number;
    account: string|undefined;
    season:string;
    team:string;
    player:string;
    isLogEnabled:boolean;
    sheets:{home:boolean, sheet:Sheet}[]|undefined;
}

export interface D1Result<T> {
    results: T[]
    success: boolean
}

export interface loginResult {
    success: boolean;
    created: boolean;
}
